module.exports = __webpack_public_path__ + "static/media/DOMI.494543d9.png";